import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  IAppointment,
  ITreatmentCategory,
  type IAccountCredit,
  type IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  type INamedDocument,
} from '@principle-theorem/shared';
import {
  type IProviderOption,
  type IResolvedTransactionOption,
} from '../transaction-providers/transaction-provider';

type MockProvider = Pick<IProviderOption, 'label'>;
export type CreditOption = IResolvedTransactionOption | MockProvider;

export interface ICreditOptionGroup {
  label: string;
  options: CreditOption[];
}

export type CreditFormData = Pick<
  IAccountCredit,
  'amount' | 'description' | 'reservedFor'
> & {
  method: CreditOption;
};

export class AccountCreditFormGroup extends TypedFormGroup<CreditFormData> {
  constructor(
    treatmentCategoryCtrl: TypedFormControl<
      DocumentReference<ITreatmentCategory>
    >
  ) {
    super({
      description: new TypedFormControl<string>('', [Validators.required]),
      amount: new TypedFormControl<number>(undefined, [Validators.required]),
      method: new TypedFormControl<IProviderOption>(undefined, [
        Validators.required,
      ]),
      reservedFor: new TypedFormGroup<IAccountCredit['reservedFor']>({
        practitioner: new TypedFormControl<INamedDocument<IStaffer>>(),
        treatment: new TypedFormControl<INamedDocument[]>(),
        appointmentRef: new TypedFormControl<DocumentReference<IAppointment>>(),
        treatmentCategory: treatmentCategoryCtrl,
      }),
    });
  }
}
